import { hashHistory } from 'react-router'
import { JIAMENG_CUSTOMER_PATH } from '@constant'
import { getMerchantInfo } from '../..'

/**
 * 点击录入客户跳转录入客户页
 * 如有手机号则携带
 */
export const goToInsertCustomer = searchText => {
  const query = {
    customerVisible: 1 // 打开客户录入的抽屉 Drawer
  }

  if (searchText) {
    query.user_phone = searchText
  }

  hashHistory.push({
    pathname: JIAMENG_CUSTOMER_PATH,
    query
  })
}

/**
 * 是否是派单商家
 */
export const isDispatchOrderMerchant = () => {
  return getMerchantInfo().is_adv == 1
}
